import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { DEFAULT_NOTIFICATION_DURATION } from '../../constants';
import { TranslateService } from '@ngx-translate/core';
import { NotificationType } from './notification.constant';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private matSnackBar: MatSnackBar, private translateService: TranslateService) {}

  success(
    translationKey: string,
    interpolateParams?: object,
    action?: string,
    duration?: number,
    messageDetails?: string,
    link?: string,
  ): MatSnackBarRef<SimpleSnackBar> {
    return this.notify(
      this.translateService.instant(translationKey, interpolateParams),
      NotificationType.Success,
      action,
      duration,
      messageDetails,
      link,
    );
  }

  warning(
    message: string,
    action?: string,
    duration?: number,
    messageDetails?: string,
    link?: string,
  ): MatSnackBarRef<SimpleSnackBar> {
    return this.notify(message, NotificationType.Warning, action, duration, messageDetails, link);
  }

  error(
    translationKey: string,
    interpolateParams?: object,
    action?: string,
    duration?: number,
    messageDetails?: string,
    link?: string,
  ): MatSnackBarRef<SimpleSnackBar> {
    translationKey = translationKey || 'api.error.common';
    return this.notify(
      this.translateService.instant(translationKey, interpolateParams),
      NotificationType.Error,
      action,
      duration,
      messageDetails,
      link,
    );
  }

  info(
    translationKey: string,
    action?: string,
    duration?: number,
    messageDetails?: string,
    link?: string,
  ): MatSnackBarRef<SimpleSnackBar> {
    return this.notify(
      this.translateService.instant(translationKey),
      NotificationType.Info,
      action,
      duration,
      messageDetails,
      link,
    );
  }

  private notify(
    message: string,
    notificationType: NotificationType,
    action?: string,
    duration: number = DEFAULT_NOTIFICATION_DURATION,
    _messageDetails?: string,
    _link?: string,
  ): MatSnackBarRef<SimpleSnackBar> {
    return this.matSnackBar.open(message, action, {
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: notificationType,
    });
  }
}
